import React, { useState, useEffect } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../Service";
import { showSnackbar } from "../../../../Components/Snackbar/SnackbarActions";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { Divider } from "@material-ui/core";
import ManageCompleteCRF from "./manage_complete_crf";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";

const options = ["Option 1", "Option 2"];

const useStyles = makeStyles((theme) => ({
  formWrapper: {
    background: "#fff",
    width: "460px",
    padding: theme.spacing(3),
  },
  title: {
    // textTransform: "",
    marginTop: "-18px",
  },
  actionButtons: {
    paddingTop: "35px",
    textAlign: "right",
    "& button": {
      marginRight: "20px",
    },
  },
  customTextField: {
    "& input::placeholder": {
      fontSize: "17px",
    },
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="subtitle1">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function ManageTemplate(props) {
  const classes = useStyles();
  const globaluserData = useSelector((state) => state.commonReducer);

  const { action, handleClose, data } = props;
  const [opencrfOpen, setCrfOpen] = [props.open, props.onClose];
  const [programmes, setProgrammes] = useState([]);
  const [openNewFeild, setOpenNewFeild] = useState("");
  // const message = useContext(ToastMessageContext);
  const [loading, setLoading] = useState(false);
  const [openNewFeildDialog, setOpenNewFeildDialog] = useState(false);
  const [CRFOpen, setCRFOpen] = useState(false);
  const [feildValue, setFeildValue] = useState([]);
  const [value, setValue] = React.useState("");
  const [inputValue, setInputValue] = React.useState("");
  const [empValue, setEmpValue] = React.useState("");
  const [submittedByValue, setSubmittedByValue] = useState("");
  const [PrgValue, setPrgValue] = React.useState("");
  const [empInputValue, setEmpInputValue] = React.useState("");
  const [submittedByInputValue, setSubmittedByInputValue] = React.useState("");
  const [prgInputValue, setPrgInputValue] = React.useState("");
  const [userData, setUserData] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [empData, setEmpData] = useState([]);
  let role = globaluserData?.role;
  let organisationId = globaluserData?.organisation_id;
  const dispatch = useDispatch();

  const handleCloseCompleteCrf = () => {
    setCrfOpen(false);
  };

  const getData = () => {
    setLoading(true);

    DataService.getDirectData(`/organisations`)
      .then((response) => {
        let listData = response["organisations"];
        if (listData && Array.isArray(listData) && listData.length > 0) {
          setApiData(listData);
        } else {
          setApiData([]);
        }
        setLoading(false);
      })
      .catch((err) => {});

    if (inputValue !== "" || role === "employee") {
      const statusData = {
        organisation_id: role === "employee" ? organisationId : value.id,
      };
      DataService.getDirectData(
        `coaching_request_forms/listing_programme`,
        statusData
      ).then((res) => {
        // if(res.success){
        if (res.programme && res.programme.length > 0) {
          let CoachinRates = res.programme;
          if (
            CoachinRates &&
            Array.isArray(CoachinRates) &&
            CoachinRates.length > 0
          ) {
            setProgrammes(CoachinRates);
          } else {
            setProgrammes([]);
          }
        }
        setLoading(false);
      });

      const params = {
        organisation_id: role === "employee" ? organisationId : value.id,
        // organisation_id: (value !== null || organisationId) ? value.id ||organisationId : null || null
      };
      DataService.getDirectData(`/coaching_request_forms/employee_list`, params)
        .then((response) => {
          let listData = response["employees"];
          if (listData && Array.isArray(listData) && listData.length > 0) {
            setEmpData(listData);
          } else {
            setEmpData([]);
          }
          setLoading(false);
        })

        .catch((err) => {});
    }
  };
  useEffect(() => {
    setLoading(true);
    getData();
  }, [inputValue, organisationId]);
  useEffect(() => {
    setFeildValue(data.module_form_fields);
  }, [feildValue, value]);

  // const getEmpData = () => {

  //   };
  //   useEffect(() => {
  //     setLoading(true);
  //     if(value !== null || inputValue === '' || organisationId){
  //     getEmpData();
  //     }
  // }, [ value,inputValue]);
  const setOpen = () => {
    setOpenNewFeild("open");
    setOpenNewFeildDialog(true);
  };
  const handleNewFeildClose = () => {
    setOpenNewFeildDialog(false);
  };
  const onChangeItem = (selectedItemValue, inputId) => {
    console.log(selectedItemValue, inputId);
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };

  const handleCreate = () => {
    setLoading(true);
    const params = {
      employee_id: empValue.id,
      programme_id: PrgValue.id,
      coaching_request_form_id: props.crfId,
      submitter_id: submittedByValue.id,
    };
    if (!params.employee_id || !params.programme_id || !params.submitter_id) {
      dispatch(
        showSnackbar("error", ["Please fill all the necessary details"], 1000)
      );
      setLoading(false);
      return;
    }
    DataService.getDirectData("/crf_users/add_crf_user_for_employee", params)
      .then((res) => {
        if (res.success) {
          // dispatch(showSnackbar("success", ["Success!"]));
          handleCloseCompleteCrf();
          props.getData();
          dispatch(showSnackbar("success", ["Success!"]));
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        dispatch(showSnackbar("error", [["" + err.errors]]));
      });
  };

  // console.log("inputValue", inputValue, value);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    for (const iterator of formData) {
      console.log(iterator);
    }

    if (action === "create") {
      handleCreate(formData);
      setCRFOpen(true);
    }
  };
  return (
    <div>
      <Dialog
        maxWidth={"sm"}
        //   fullWidth={true}
        style={{ height: "70%", marginTop: "50px" }}
        open={opencrfOpen}
        onClose={handleCloseCompleteCrf}
        aria-labelledby="base-station-manage"
      >
        <DialogTitle id="customized-dialog-title">
          {action === "edit" && (
            <IconButton
              className={classes.iconButton}
              onClick={handleClose}
              aria-label="menu"
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          {action === "edit" ? "Edit template" : ""}
          Complete a CRF
        </DialogTitle>
        <Divider />
        <DialogContent style={{ margin: "2px" }}>
          {action !== "delete" ? (
            <div className={classes.formWrapper}>
              <Typography
                variant="subtitle2"
                color="secondary"
                className={classes.title}
              >
                {/* {action !== "edit" ? `${action}Modules` :''}  */}
              </Typography>
              {/* <form onSubmit={handleSubmit}> */}

              <div>
                {action === true ? (
                  <>
                    <Grid
                      container
                      spacing={1}
                      alignItems={"center"}
                      justify={"flex-start"}
                    >
                      {role === "employee" ? (
                        ""
                      ) : (
                        <React.Fragment>
                          <Grid item xs={4}>
                            <Typography
                              variant="h2"
                              color="secondary"
                              className={classes.title}
                            >
                              Organization name
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Autocomplete
                              value={value}
                              onChange={(event, newValue) => {
                                if (newValue === null) {
                                  //Just give a value to a value to avoid null
                                  //e.g. value = ""
                                  newValue = "";
                                }
                                setValue(newValue);
                              }}
                              // classes={{
                              //     input: classes.autoComplete,
                              //     option: classes.autoComplete
                              // }}
                              disabled={role === "employee" ? true : false}
                              inputValue={inputValue}
                              onInputChange={(event, newInputValue) => {
                                setInputValue(newInputValue);
                              }}
                              id="controllable-states-demo"
                              options={apiData}
                              getOptionLabel={(option) =>
                                option.organisation_name
                              }
                              style={{ width: 280 }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  classes={{ root: classes.customTextField }}
                                  inputProps={{
                                    ...params.inputProps,
                                    style: { fontSize: "16px" },
                                  }}
                                  placeholder="Organization name"
                                  InputLabelProps={{
                                    style: {
                                      fontSize: "16px",
                                      fontFamily: "Open Sans",
                                    },
                                  }}
                                  autoFocus
                                  variant="outlined"
                                />
                              )}
                            />
                            <br />{" "}
                          </Grid>
                        </React.Fragment>
                      )}

                      <Grid item xs={4}>
                        <Typography
                          variant="h2"
                          color="secondary"
                          className={classes.title}
                        >
                          Program name
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Autocomplete
                          value={PrgValue}
                          onChange={(event, newValue) => {
                            setPrgValue(newValue);
                          }}
                          size={"medium"}
                          inputValue={prgInputValue}
                          onInputChange={(event, newInputValue) => {
                            setPrgInputValue(newInputValue);
                          }}
                          classes={{
                            input: classes.autoComplete,
                            option: classes.autoComplete,
                          }}
                          id="controllable-states-demo"
                          options={programmes}
                          getOptionLabel={(option) => option.name}
                          style={{ width: 280, fontSize: "16px" }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              classes={{ root: classes.customTextField }}
                              inputProps={{
                                ...params.inputProps,
                                style: { fontSize: "16px" },
                              }}
                              placeholder="Program name"
                              InputLabelProps={{
                                style: {
                                  fontSize: "16px",
                                  fontFamily: "Open Sans",
                                },
                              }}
                              // autoFocus
                              variant="outlined"
                            />
                          )}
                        />
                        <br />{" "}
                      </Grid>
                      <Grid item xs={4}>
                        <Typography
                          variant="h2"
                          color="secondary"
                          className={classes.title}
                        >
                          Employee name
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Autocomplete
                          value={empValue}
                          onChange={(event, newValue) => {
                            setEmpValue(newValue);
                          }}
                          size={"medium"}
                          inputValue={empInputValue}
                          onInputChange={(event, newInputValue) => {
                            setEmpInputValue(newInputValue);
                          }}
                          classes={{
                            input: classes.autoComplete,
                            option: classes.autoComplete,
                          }}
                          id="controllable-states-demo"
                          options={empData}
                          getOptionLabel={(option) => option.full_name}
                          style={{ width: 280, fontSize: "16px" }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              classes={{ root: classes.customTextField }}
                              inputProps={{
                                ...params.inputProps,
                                style: { fontSize: "16px" },
                              }}
                              placeholder="Employee name"
                              style={{ paddding: "0px" }}
                              // autoFocus
                              variant="outlined"
                            />
                          )}
                        />
                        {/* <div>{`value: ${value !== null ? `'${value}'` : 'null'}`}</div>
      <div>{`inputValue: '${inputValue}'`}</div> */}
                        <br />{" "}
                      </Grid>
                      <Grid item xs={4}>
                        <Typography
                          variant="h2"
                          color="secondary"
                          className={classes.title}
                        >
                          Submitted by
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Autocomplete
                          value={submittedByValue}
                          onChange={(event, newValue) => {
                            setSubmittedByValue(newValue);
                          }}
                          size={"medium"}
                          inputValue={submittedByInputValue}
                          onInputChange={(event, newInputValue) => {
                            setSubmittedByInputValue(newInputValue);
                          }}
                          classes={{
                            input: classes.autoComplete,
                            option: classes.autoComplete,
                          }}
                          id="controllable-states-demo"
                          options={empData}
                          getOptionLabel={(option) => option.full_name}
                          style={{ width: 280, fontSize: "16px" }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              classes={{ root: classes.customTextField }}
                              inputProps={{
                                ...params.inputProps,
                                style: { fontSize: "16px" },
                              }}
                              placeholder="Submitted by"
                              style={{ paddding: "0px" }}
                              // autoFocus
                              variant="outlined"
                            />
                          )}
                        />
                        {/* <div>{`value: ${value !== null ? `'${value}'` : 'null'}`}</div>
      <div>{`inputValue: '${inputValue}'`}</div> */}
                        <br />{" "}
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      spacing={1}
                      justify={"flex-end"}
                      style={{ marginTop: 20 }}
                    >
                      <Grid item xs={3}>
                        <Button
                          disableElevation
                          disabled={loading}
                          type="button"
                          style={{ textTransform: "initial" }}
                          variant={"contained"}
                          onClick={handleCloseCompleteCrf}
                        >
                          Cancel
                        </Button>
                      </Grid>
                      <Grid item xs={3}>
                        <Button
                          disabled={loading}
                          type="submit"
                          onClick={handleCreate}
                          variant={"contained"}
                          color="secondary"
                          style={{ textTransform: "initial" }}
                        >
                          {loading && (
                            <CircularProgress
                              className={classes.circularProgress}
                              size={20}
                            />
                          )}
                          Create
                        </Button>
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  ""
                )}

                {action === "edit" ? (
                  <Button
                    disableElevation
                    onClick={setOpen}
                    disabled={loading}
                    variant={"contained"}
                    color="primary"
                  >
                    {loading && (
                      <CircularProgress
                        className={classes.circularProgress}
                        size={20}
                      />
                    )}
                    Update Name
                  </Button>
                ) : (
                  ""
                )}
              </div>
              {/* </form> */}
            </div>
          ) : (
            <div className={classes.formWrapper}>
              Warning, deleting this module will delete both the module and
              their items from the ordering list. Are you sure?
              <div className={classes.actionButtons}>
                <Button
                  disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  onClick={handleClose}
                  style={{ textTransform: "initial" }}
                >
                  Cancel
                </Button>
                <Button
                  disableElevation
                  disabled={loading}
                  type="button"
                  variant={"contained"}
                  color="primary"
                  style={{ textTransform: "initial" }}
                >
                  Yes, Confirm
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
      )
      {CRFOpen && (
        <ManageCompleteCRF
          action={CRFOpen}
          moduleId={data.id}
          moduleSetup={props.moduleSetup}
          data={data}
          handleClose={handleClose}
        />
      )}
    </div>
  );
}

export default ManageTemplate;
